import React, { useContext, useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { IoIosArrowForward } from "react-icons/io";
import { useLocation, Link } from "react-router-dom";
import { AppContext } from "../ContextApi";
import {
  myOrdersIcon,
  claimStausIcon,
  dashboardIcon,
  downloadformsIcon,
  healthRecordIcon,
  IntimateclaimsIcon,
  dashboardFAQIcon,
  matrixIcon,
  membersCoveredIcon,
  myCoverageIcon,
  policyDetailsIcon,
  networkHospitalIcon,
  claimSubmissionIcon,
  dashboardBlackListedIcon,
  dashboardQueriesIcon,
} from "../Assets/index";

import { APP_ORDER_URL, APP_HEALTH_RECORDS_URL } from "../Constants";
import "../styles/sidebar.css";

const SidebarComp = ({ collapsed, setCollapsed }) => {
  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const { featuresType, tabapiData, checkQueriesModule } =
    useContext(AppContext);

  const [appLinkToken] = useState(localStorage.getItem("appLinkToken"));

  const checkVisibility = (key) =>
    tabapiData?.find((item) => item.policy_type_name === featuresType)?.[
      key
    ] === 1;

  const showGMC =
    featuresType === "GMC" ||
    featuresType === "Top Up Policy" ||
    featuresType === "Parent Policy";
  const showGPAorGTL = featuresType === "GPA" || featuresType === "GTL";

  const location = useLocation();
  const fullPath = location.pathname + location.search;

  const isActive = (url) => fullPath.startsWith(url);

  return (
    <div className="dashboard-sidebar-main-cover">
      <Sidebar
        collapsed={collapsed}
        className="custom-sidebar-main-cover-wrapper"
      >
        <Menu iconShape="square" className="custom-sidebar-inner-cover-wrapper">
          <Link to="/home">
            <MenuItem
              icon={<img src={dashboardIcon} alt="" style={{ width: 18 }} />}
              className={isActive("/dashboard") ? "active-sidebar-item" : ""}
            >
              Dashboard
            </MenuItem>
          </Link>
          <Link to="/policy-details">
            <MenuItem
              icon={
                <img src={policyDetailsIcon} alt="" style={{ width: 18 }} />
              }
              className={
                isActive("/policy-details") ? "active-sidebar-item" : ""
              }
            >
              Policy Details
            </MenuItem>
          </Link>
          <Link to="/mycoverage">
            <MenuItem
              icon={<img src={myCoverageIcon} alt="" style={{ width: 18 }} />}
              className={isActive("/mycoverage") ? "active-sidebar-item" : ""}
            >
              My Coverages
            </MenuItem>
          </Link>
          <Link to="/members-covered">
            <MenuItem
              icon={
                <img src={membersCoveredIcon} alt="" style={{ width: 18 }} />
              }
              className={
                isActive("/members-covered") ? "active-sidebar-item" : ""
              }
            >
              Members Covered
            </MenuItem>
          </Link>
          <Link to="/claim-corner">
            <MenuItem
              icon={<img src={claimStausIcon} alt="" style={{ width: 18 }} />}
              className={isActive("/claim-corner") ? "active-sidebar-item" : ""}
            >
              Claims Corner
            </MenuItem>
          </Link>

          {/* {(showGMC || showGPAorGTL) && (
            <Link to={checkVisibility("intimate_claim_visibility") ? "/intimate-myclaims" : ""}>
              <MenuItem
                icon={
                  <img src={IntimateclaimsIcon} alt="" style={{ width: 18 }} />
                }
                disabled={!checkVisibility("intimate_claim_visibility")}
                className={
                  isActive("/intimate-myclaims") ? "active-sidebar-item" : ""
                }
              >
                Intimate My Claim
              </MenuItem>
            </Link>
          )} */}

          {(showGMC || showGPAorGTL) && (
            <Link
              to={
                checkVisibility("claim_submission_visibility")
                  ? "/claim-submission"
                  : ""
              }
            >
              <MenuItem
                icon={
                  <img src={claimSubmissionIcon} alt="" style={{ width: 18 }} />
                }
                disabled={!checkVisibility("claim_submission_visibility")}
                className={
                  isActive("/claim-submission") ? "active-sidebar-item" : ""
                }
              >
                Claim Submission
              </MenuItem>
            </Link>
          )}

          {showGMC && (
            <>
              <Link to="/escalation-matrix">
                <MenuItem
                  icon={<img src={matrixIcon} alt="" style={{ width: 18 }} />}
                  className={
                    isActive("/escalation-matrix") ? "active-sidebar-item" : ""
                  }
                >
                  Escalation Matrix
                </MenuItem>
              </Link>

              <Link to="/network-hospital">
                <MenuItem
                  icon={
                    <img
                      src={networkHospitalIcon}
                      alt=""
                      style={{ width: 18 }}
                    />
                  }
                  className={
                    isActive("/network-hospital") ? "active-sidebar-item" : ""
                  }
                >
                  Network Hospital
                </MenuItem>
              </Link>

              <Link to="/download-form">
                <MenuItem
                  icon={
                    <img src={downloadformsIcon} alt="" style={{ width: 18 }} />
                  }
                  className={
                    isActive("/download-form") ? "active-sidebar-item" : ""
                  }
                >
                  Download Forms
                </MenuItem>
              </Link>
            </>
          )}
          {checkQueriesModule == 1 && (
            <Link to="/queries">
              <MenuItem
                icon={
                  <img src={dashboardQueriesIcon} alt="" style={{ width: 18 }} />
                }
                className={isActive("/queries") ? "active-sidebar-item" : ""}
              >
                Queries
              </MenuItem>
            </Link>
          )}
          {/* <Link to="/blacklisted-hospital">
            <MenuItem
              icon={<img src={dashboardBlackListedIcon} alt="" style={{ width: 18 }} />}
              className={
                isActive("/blacklisted-hospital") ? "active-sidebar-item" : ""
              }
            >
              Black Listed Hospital
            </MenuItem>
          </Link> */}
          {checkVisibility("faq_visibility") && (
            <Link to="/faq">
              <MenuItem
                icon={
                  <img src={dashboardFAQIcon} alt="" style={{ width: 18 }} />
                }
                className={isActive("/faq") ? "active-sidebar-item" : ""}
              >
                FAQ's
              </MenuItem>
            </Link>
          )}
        </Menu>
      </Sidebar>

      <Menu className="sidebar-menu-btn">
        <MenuItem icon={<IoIosArrowForward />} onClick={handleToggle} />
      </Menu>
    </div>
  );
};

export default SidebarComp;
